"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

exports.setDevEnv = setDevEnv;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hierarchy = (0, _stringify2.default)({
  data: {
    hierarchy: [{
      id: 51,
      name: "Engineering Test Business",
      description: "AdParlor",
      created_by: 1,
      updated_by: 2876,
      product_type: "managed",
      status: "ACTIVE_BUSINESS",
      self_status: "ACTIVE_BUSINESS",
      generic_status: 1,
      address1: "129 Spadina Ave.",
      address2: null,
      state: null,
      zip: null,
      country: null,
      image_path: "/uploaded/images/global/3572b39aeb966d020d4a02d8d5cff378.png",
      thumbnail_image_path: "/uploaded/images/global/3572b39aeb966d020d4a02d8d5cff378-200x200.png",
      twitter_enabled: true,
      facebook_enabled: true,
      trivu_enabled: true,
      dbm_enabled: true,
      youtube_enabled: true,
      yahoo_enabled: false,
      pinterest_enabled: true,
      snapchat_enabled: true,
      dcm_enabled: false,
      advertisers: [{
        id: 54,
        name: "Peoples Farm",
        created_by: null,
        updated_by: 220,
        industry_id: 20,
        status: "ACTIVE_ADVERTISER",
        inherited_status: "ACTIVE_BUSINESS",
        self_status: "ACTIVE_ADVERTISER",
        generic_status: 1,
        image_path: "/uploaded/images/advertiser_54/c9755ea42775a3da27a4301891c09bc0.jpg",
        thumbnail_image_path: "/uploaded/images/advertiser_54/c9755ea42775a3da27a4301891c09bc0-200x200.jpg",
        business_id: 51,
        agency_id: null,
        currency_code: "USD",
        facebook_enabled: true,
        twitter_enabled: true,
        trivu_enabled: true,
        dbm_enabled: true,
        youtube_enabled: true,
        yahoo_enabled: false,
        pinterest_enabled: true,
        snapchat_enabled: true
      }, {
        id: 55,
        name: "AOL",
        created_by: 5,
        updated_by: 2735,
        industry_id: 20,
        status: "ACTIVE_ADVERTISER",
        inherited_status: "ACTIVE_BUSINESS",
        self_status: "ACTIVE_ADVERTISER",
        generic_status: 1,
        image_path: "/uploaded/images/global/3572b39aeb966d020d4a02d8d5cff378.png",
        thumbnail_image_path: "/uploaded/images/global/a7e512711abf5cc35e6404ed8f260944-200x200.png",
        business_id: 51,
        agency_id: null,
        currency_code: "CAD",
        facebook_enabled: true,
        twitter_enabled: true,
        trivu_enabled: true,
        dbm_enabled: true,
        youtube_enabled: true,
        yahoo_enabled: false,
        pinterest_enabled: true,
        snapchat_enabled: true
      }, {
        id: 3631,
        name: "High & Dry Media Inc.",
        created_by: 6,
        updated_by: 6,
        industry_id: 20,
        status: "ACTIVE_ADVERTISER",
        inherited_status: "ACTIVE_BUSINESS",
        self_status: "ACTIVE_ADVERTISER",
        generic_status: 1,
        image_path: "/uploaded/images/global/3572b39aeb966d020d4a02d8d5cff378.png",
        thumbnail_image_path: "/uploaded/images/global/80e0dd4feddda32ec22ec6298e513375-200x200.png",
        business_id: 51,
        agency_id: null,
        currency_code: "USD",
        facebook_enabled: true,
        twitter_enabled: true,
        trivu_enabled: true,
        dbm_enabled: true,
        youtube_enabled: true,
        yahoo_enabled: false,
        pinterest_enabled: true,
        snapchat_enabled: true
      }],
      sales_region_office_id: 1,
      support_agencies: true,
      agencies: [],
      currency_code: "USD",
      next_billing_date: null,
      trial_end_date: null,
      trial_expired: null
    }]
  }
});

var user = (0, _stringify2.default)({
  id: 2695,
  email: "bsheikh@adparlor.com",
  first_name: "Bill",
  last_name: "Sheikh",
  last_sign_in_at: "2017-05-19T15:39:32.000Z",
  image_path: null,
  thumbnail_image_path: null,
  facebook_url: "",
  linkedin_url: null,
  skype_id: null,
  twitter_handle: null,
  company: "Adparlor",
  position: "Frontend Developer",
  is_adparlor: true,
  is_adparlor_super: false,
  is_super: false,
  status: "ACTIVE",
  phone_number: "911 :)",
  phone_number_extension: "",
  roles: ["BUSINESS_51", "ADVERTISER_54", "ADVERTISER_71", "ADVERTISER_75", "ADVERTISER_87", "ADVERTISER_118", "ADVERTISER_3100"],
  business_ids: [51],
  has_financial_access: null,
  preferred_language: "eng",
  read_only: null,
  facebook_enabled: true,
  twitter_enabled: true,
  trivu_enabled: true,
  dbm_enabled: true,
  youtube_enabled: true,
  yahoo_enabled: false,
  pinterest_enabled: true,
  snapchat_enabled: true,
  created_at: "2016-05-09T18:40:58.000Z",
  desk_url: "http://support.adparlor.com/customer/authentication/multipass/callback?multipass=W%2F20cTUNQ%2FTTtVul5ideR83NJmsIJNkkuyMYLu3KbGSqqeea04FY5t0y74Tm%0A09pdcbGiyIsYuAQb6RTNC6BT1ZuuSDo9zDznnuxaQNBjZRwNEex915SW%2BfFa%0AKHBN2CWRCId3%2FET9213UcvbVzLlVJIlsrBriqNVbK0yU%2BBoQuAkL8%2FuvfSbC%0AlQKB04HRILo6%0A&signature=c2veQWE5AIS9eVlffREqWPTRuvw%3D%0A"
});

var ADVERTISERS_AVAIABLE = [54, 55, 3631];

function setDevEnv() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!options.WSSE) {
    throw new Error('Error: WSSE token is not provided. Please enter a valid Sandbox or Production WSSE token.');
  }

  localStorage.setItem("user_language", "eng");
  localStorage.setItem("System.LocalStorage.Hierarchy", options.hierarchy || hierarchy);
  localStorage.setItem("User", options.user || user);
  localStorage.setItem("WSSE", options.WSSE);

  if (!ADVERTISERS_AVAIABLE.includes(parseInt(localStorage.getItem("ADK_ADVERTISER_ID"), 10))) {
    localStorage.setItem("ADK_ADVERTISER_ID", "" + ADVERTISERS_AVAIABLE[0]);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/js-anvil/lib/config/dev-config/index.js
// module id = 44
// module chunks = 0